
import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ApplicationSandbox as CoreSandbox } from '@portable/core/sandbox';
import { ConfigService } from 'src/shared/services/config.service';  // TODO: DEP; use environment.ts
import { ProfileService } from 'src/shared/services/profile.service';
import { AccountService } from 'src/shared/services/account.service';
import { PlatformService } from 'src/shared/services/platform.service';
import { UserService } from 'src/app/services/user/user.service';
import { Director } from 'src/app/director/director';
import { ServiceUtil } from 'src/shared/utilities/service.util';

@Injectable()
class ApplicationSandbox extends CoreSandbox {
	protected override director: Director;
	
	constructor(
        _serviceUtil: ServiceUtil, 
        router: Router, 
        oidc: OidcSecurityService, 
        config: ConfigService, 
        profile: ProfileService, 
        account: AccountService, 
        platform: PlatformService, 
		configService: ConfigService,
        zone: NgZone) {
		super();

		this.director = new Director(oidc,configService);
		this.director.init({  // services must be instantiated after director is available on sandbox to obviate Race Conditions
			router,
			user: new UserService(_serviceUtil, this, oidc, profile),
			profile,
			account,
			platform,
			config
		});
	}
	
	override publish(...args: any[]) {
		super.publish.apply(this, args);
		return this;
	}
	override subscribe(...args: any[]) {
		super.subscribe.apply(this, args);
		return this;
	}
	override unsubscribe(...args: any[]) {
		super.unsubscribe.apply(this, args);
		return this;
	}
	
}

export { ApplicationSandbox as Sandbox };
